import { countIntervalIntersectionsWithHeadcount } from './countIntervalIntersectionsWithHeadcount';
import  { computeRemainingSpots } from './computeRemainingSpots';
import  { countReservationIntervalIntersections } from './countIntervalIntersections';
import { getBookingHeadcount } from './getBookingHeadcount';
import  { mergeUserCapReachedIntervals } from './mergeUserCapReachedIntervals';
import  { mapPostgresTimeRange } from 'async-timing';

interface ReservationResult {
  contentId: string;
  contentInteractionId: string;
  reservation: string;
  eventType: string | null;
  guestsCount?: number;
}

export function computeHeadcountAwareAvailability({
  allReservations,
  myReservations,
  maxQuantityPerSlot,
  maxQuantityPerSlotPerUser,
}: {
  allReservations: ReservationResult[];
  myReservations: ReservationResult[];
  maxQuantityPerSlot: number;
  maxQuantityPerSlotPerUser: number;
}) {
  const headcountReservations = allReservations.map(result => ({
    interval: mapPostgresTimeRange(result.reservation),
    eventType: result.eventType,
    headcount: getBookingHeadcount(result.guestsCount),
  }));

  const intervalCounts =
    countIntervalIntersectionsWithHeadcount(headcountReservations);

  const globalIntervals = computeRemainingSpots(
    intervalCounts,
    maxQuantityPerSlot
  );

  const myIntervalCounts = countReservationIntervalIntersections(
    myReservations.map(result => ({
      interval: mapPostgresTimeRange(result.reservation),
      eventType: result.eventType,
    }))
  );

  const userBlockedIntervals = myIntervalCounts
    .filter(i => i.count >= maxQuantityPerSlotPerUser)
    .map(i => ({ interval: i.interval, eventType: i.eventType }));

  return mergeUserCapReachedIntervals(
    globalIntervals,
    userBlockedIntervals,
    maxQuantityPerSlot
  ).map(i => ({
    startDate: i.startDate,
    endDate: i.endDate,
    eventType: i.eventType,
    remainingSpots: i.remainingSpots,
    reason: i.reason,
  }));
}
